exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-menu{background:#55988d!important;box-shadow:5px 5px 40px}@media (max-width:600px){.step-progress__bar{height:50px}.bg-menu{background:transparent!important;box-shadow:0 0 0}.header_menu{box-shadow:10px 10px 20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f197205e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/GrayZone/Quotation.vue
// module id = 913
// module chunks = 0